
import { useState, useEffect } from "react";

interface UseRetryLogicProps {
  error: string | null;
  refetch: () => void;
}

export function useRetryLogic({ error, refetch }: UseRetryLogicProps) {
  const [isRetrying, setIsRetrying] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const MAX_RETRIES = 3;

  useEffect(() => {
    if (error && retryCount < MAX_RETRIES) {
      setIsRetrying(true);
      // Exponential backoff: 2s, 4s, 8s
      const retryDelay = Math.min(2000 * Math.pow(2, retryCount), 8000);
      const timeout = setTimeout(() => {
        refetch();
        setRetryCount(prev => prev + 1);
      }, retryDelay);
      
      return () => clearTimeout(timeout);
    } else if (!error) {
      setIsRetrying(false);
      setRetryCount(0);
    } else {
      // Max retries reached, stop retrying
      setIsRetrying(false);
    }
  }, [error, retryCount, refetch]);

  const retryFetch = () => {
    setIsRetrying(true);
    setRetryCount(0);
    refetch();
  };

  return {
    isRetrying,
    retryFetch
  };
}
